import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useRive, useStateMachineInput } from "@rive-app/react-canvas";
import OH from "../rive/4.riv";
import { replaceWithDataSource } from "../helpers/variable";

// export default function Rive() {
// 	return null;
// }

export default function Rive({ cue, cloud }) {
	const { projectId } = useParams();
	const dynamicText = useSelector(
		(state) => state.main?.projects?.[projectId]?.dynamicText
	);
	const dynamicLists = useSelector(
		(state) => state.main?.projects?.[projectId]?.dynamicLists
	);
	const { rive, RiveComponent } = useRive({
		src: OH,
		autoplay: true,
		stateMachines: "State Machine 1",
		buffer: (buff) => {
			console.log(buff);
		},
	});

	const bumpInput = useStateMachineInput(rive, "State Machine 1", "Boolean 1");

	const handleSetTrue = (bool) => {
		if (bumpInput) {
			bumpInput.value = bool;
		}
	};

	useEffect(() => {
		if (rive) {
			console.log(
				"Rive text was initially: ",
				rive?.getTextRunValue("GFX_NAME")
			);
			// handleSetTrue();
			rive?.setTextRunValue(
				"GFX_NAME",
				replaceWithDataSource(cue?.line_one, dynamicText, dynamicLists) || ""
			);
			rive?.setTextRunValue(
				"GFX_TITLE",
				replaceWithDataSource(cue?.line_two, dynamicText, dynamicLists) || ""
			);
			console.log("Rive text is now: ", rive?.getTextRunValue("GFX_NAME"));
		}
	}, [
		rive,
		cue?.line_one,
		cue?.line_two,
		bumpInput,
		dynamicText,
		dynamicLists,
	]);

	useEffect(() => {
		if (rive) {
			if (cue.status === "coming") {
				handleSetTrue(false);
			} else if (cue.status === "going") {
				handleSetTrue(true);
			}
		}
	}, [rive, cue.status]);

	return (
		<div className="w-screen h-screen">
			<RiveComponent />
		</div>
	);
}
